module.exports = __webpack_public_path__ + "static/media/icon-calendar-check.c7fb4b51.svg";